import type { NewsletterMagazineNode } from 'data-layer';
import { NewsletterMagazine } from '../../newsletter/variants/NewsletterMagazine';
import type { KeyVisualVariantProps } from '../types';

/**
 * Renders a NewsletterMagazine as a page KeyVisual.
 */
export function KeyVisualNewsletterMagazine(props: KeyVisualVariantProps) {
  const { keyVisual } = props;

  return (
    <NewsletterMagazine
      className="key-visual__newsletter-magazine"
      props={keyVisual as NewsletterMagazineNode}
      articleTheme={(keyVisual as NewsletterMagazineNode).articleTheme}
      isUsedAsKeyVisual
    />
  );
}
